import React from 'react';
import styles from '../styles/inicio.module.css';

const Inicio = () => {
    return (
        <div className={styles.inicio}>
            <div className={styles.welcomeCard}>
                <h1 className={styles.title}>Bienvenido al Panel de Empresa</h1>
                <p className={styles.subtitle}>
                    Selecciona una sección en el menú lateral para comenzar: 4 Creatividades, 360º Creative Leadership, Covisage o Systemic Survey.
                </p>
            </div>
        </div>
    );
};

export default Inicio;
